export default __webpack_public_path__ + "static/media/404.b1b1918a.svg";